import classNames from "classnames"

import { StaffLabelTextXS } from "@doktor-se/bones-ui"

import styles from "./ListHeader.module.scss"

interface ListHeaderProps {
  columns: { key: string; name: string }[]
  additionalColumn?: boolean
  onHeaderClick?: (key: string) => void
  sortKey?: string
  sortDir?: "asc" | "desc"
}

const ListHeader = ({
  columns,
  additionalColumn = false,
  onHeaderClick,
  sortKey,
  sortDir = "asc"
}: ListHeaderProps) => {
  return (
    <div className={styles.header}>
      {columns.map(column => {
        const isActive = sortKey === column.key
        return (
          <div
            className={classNames(styles.label, styles[column.key])}
            key={column.key}
            role={onHeaderClick ? "button" : undefined}
            tabIndex={onHeaderClick ? 0 : undefined}
            onClick={onHeaderClick ? () => onHeaderClick(column.key) : undefined}
            onKeyDown={
              onHeaderClick ? e => (e.key === "Enter" || e.key === " ") && onHeaderClick(column.key) : undefined
            }>
            <StaffLabelTextXS>{`${column.name}${isActive ? (sortDir === "asc" ? " ▲" : " ▼") : ""}`}</StaffLabelTextXS>
          </div>
        )
      })}
      {additionalColumn && <div className={styles.additionalColumn} />}
    </div>
  )
}

export default ListHeader
